const classes = (theme) => ({
  container: {
    paddingBottom: theme.spacing(1),
  },
  promoTitle: {
    color: theme.palette.primary.main,
    fontSize: 14,
    cursor: 'pointer',
  },
  modalContainer: {
    padding: theme.spacing(2.5),
    fontWeight: 300,
    '& .title': {
      fontSize: 24,
      display: 'block',
      paddingBottom: theme.spacing(2.5),
      '& br': {
        display: 'none',
      },
    },
    '& .title_two': {
      fontSize: 20,
      paddingBottom: theme.spacing(2.5),
      '& *': {
        // inline styles are used here. So no way to avoid important
        color: `${theme.palette.text.primary} !important`,
      },
    },
    '& [class^="disc"]': {
      fontSize: 14,
    },
  },
});

export default classes;
